<template>
	<div class="content">
	  <base-header class="pb-6">
		<div class="row align-items-center py-4">
		  <div class="col-lg-6 col-7">
			<h6 class="h2 text-white d-inline-block mb-0">
			  {{ $t("wms.menu.inventory_history_storage_list") }}
			</h6>
			<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
			  <route-bread-crumb></route-bread-crumb>
			</nav>
		  </div>
		</div>
	  </base-header>
	  <div class="container-fluid mt--6">
		<div>
		  <card
			class="no-border-card"
			body-classes="px-0 pb-1"
			footer-classes="pb-2"
		  >
			<template slot="header">
			  <div class="row">
  
				<div class="form-group row">
				  <div class="col-md-2">
					<base-input>
					  <flat-picker
						slot-scope="{ focus, blur }"
						@on-open="focus"
						@on-close="blur"
						:config="{ allowInput: true, enableTime: true,dateFormat: 'Y-m-d H:i',time_24hr: true }"
						class="form-control datepicker"
						v-model="startDate"
					  >
					  </flat-picker>
					</base-input>
				  </div>
  
				  <div class="col-md-2">
					<base-input>
					  <flat-picker
						slot-scope="{ focus, blur }"
						@on-open="focus"
						@on-close="blur"
						:config="{ allowInput: true ,enableTime: true,dateFormat: 'Y-m-d H:i',time_24hr: true }"
						class="form-control datepicker"
						v-model="endDate"
					  >
					  </flat-picker>
					</base-input>
				  </div>
  
				  <div class="col-md-2">
                <base-input>
                  <el-select
                    v-model="StorageID"
                    :placeholder="$t('wms.storage')"
					filterable
                  >
                    <el-option
                      v-for="option in Storage"
                      :key="option.ID"
                      :label="option.Name"
                      :value="option.ID"
                    >
                    </el-option>
                  </el-select>
                </base-input>
              </div>

			  <div class="col-md-2">
                <base-input>
                  <el-select
                    v-model="historyType"
                    :placeholder="$t('wms.history_type')"
					filterable
                  >
                    <el-option
                      v-for="option in HistoryTypeTable"
                      :key="option.ID"
                      :label="option.Name"
                      :value="option.ID"
                    >
                    </el-option>
                  </el-select>
                </base-input>
              </div>
			  <div class="col-md-2">
                <base-input>
                  <el-select
                    v-model="wmsProductID"
                    :placeholder="$t('wms.product')"
					filterable
                  >
                    <el-option
                      v-for="option in Product"
                      :key="option.ID"
                      :label="option.Name"
                      :value="option.ID"
                    >
                    </el-option>
                  </el-select>
                </base-input>
              </div>
  
				  <div class="col-md-1">
					<base-button size="md" type="neutral" @click="SearchData()">
					  Search
					</base-button>
				  </div>
				</div>
			  </div>
			</template>
			<div>
			  <el-table
				:data="queriedData"
				row-key="id"
				header-row-class-name="thead-light"
				@sort-change="sortChange"
				@selection-change="selectionChange"
			  >
				<el-table-column
				  v-for="column in tableColumns"
				  :key="column.label"
				  v-bind="column"
				>
				</el-table-column>
  
				<el-table-column
				  min-width="200px"
				  align="right"
				  :label="$t('actions')"
				>
				  <div slot-scope="{ $index, row }" class="d-flex">
					<base-button
					  @click.native="handleDetail($index, row)"
					  class="edit"
					  type="warning"
					  size="sm"
					  icon
					>
					  <i class="text-dtac-bt fa fa-edit"></i>
					  Detail
					</base-button>
				  </div>
				</el-table-column>
			  </el-table>
			</div>
			<div
			  slot="footer"
			  class=" col-12 d-flex justify-content-center justify-content-sm-between flex-wrap "
			  v-if="tableData.length != 0"
			>
			  <div class="">
				<p class="card-category">
				  {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
				  {{ $t("of") }}
				  {{ total }}
				  <span v-if="selectedRows.length">
					- &nbsp; &nbsp; {{ selectedRows.length }}
					{{ $t("row_select") }}
				  </span>
				</p>
			  </div>
			  <base-pagination
				class="pagination-no-border"
				v-model="pagination.currentPage"
				:per-page="pagination.perPage"
				:total="total"
			  >
			  </base-pagination>
			</div>
		  </card>
		</div>
	  </div>
  
	  <modal :show.sync="showAddModal" modal-classes="modal-secondary">
		<form class="new-event--form" @submit.prevent="saveEvent">
		  <base-input
			:label="$t('wms.product')"
			input-classes="form-control-alternative new-event--title"
		  >
			<el-select v-model="md.ProductID" :placeholder="$t('wms.product')">
			  <el-option
				v-for="option in Product"
				:key="option.ID"
				:label="option.Name"
				:value="option.ID"
			  >
			  </el-option>
			</el-select>
		  </base-input>
  
		  <base-input
			:label="$t('wms.storage')"
			input-classes="form-control-alternative new-event--title"
		  >
			<el-select v-model="md.StorageID" :placeholder="$t('wms.storage')">
			  <el-option
				v-for="option in Storage"
				:key="option.ID"
				:label="option.Name"
				:value="option.ID"
			  >
			  </el-option>
			</el-select>
		  </base-input>
  
		  <base-input
			v-model="md.Quantity"
			:label="$t('wms.amount')"
			input-classes="form-control-alternative new-event--title"
		  >
		  </base-input>
  
		  <base-input
			v-model="md.Cost"
			:label="$t('wms.cost')"
			input-classes="form-control-alternative new-event--title"
		  >
		  </base-input>
  
		  <base-input
			v-model="md.Note"
			:label="$t('wms.note')"
			input-classes="form-control-alternative new-event--title"
		  >
		  </base-input>
  
		  <input type="hidden" class="new-event--start" />
		  <input type="hidden" class="new-event--end" />
		</form>
  
		<template slot="footer">
		  <button
			type="submit"
			class="btn btn-md btn-primary"
			@click="handleUpdate()"
		  >
			{{ $t("save") }}
		  </button>
		  <button
			type="button"
			class="btn btn-md btn-link ml-auto"
			@click="showAddModal = false"
		  >
			{{ $t("close") }}
		  </button>
		</template>
	  </modal>
  
	  <modal :show.sync="showInOutModal" modal-classes="modal-secondary">
		<form class="new-event--form" @submit.prevent="saveEvent">
		  <base-input
			v-model="inOut.Quantity"
			:label="$t('wms.amount')"
			input-classes="form-control-alternative new-event--title"
		  >
		  </base-input>
  
		  <base-input
			v-model="inOut.Cost"
			:label="$t('wms.cost')"
			input-classes="form-control-alternative new-event--title"
		  >
		  </base-input>
  
		  <base-input
			v-model="inOut.Note"
			:label="$t('wms.note')"
			input-classes="form-control-alternative new-event--title"
		  >
		  </base-input>
  
		  <input type="hidden" class="new-event--start" />
		  <input type="hidden" class="new-event--end" />
		</form>
  
		<template slot="footer">
		  <button
			type="submit"
			class="btn btn-md btn-primary"
			@click="handleUpdateInOut()"
		  >
			{{ $t("save") }}
		  </button>
		  <button
			type="button"
			class="btn btn-md btn-link ml-auto"
			@click="showInOutModal = false"
		  >
			{{ $t("close") }}
		  </button>
		</template>
	  </modal>
	</div>
  </template>
  <script>
  import { Table, TableColumn, Select, Option } from "element-ui";
  import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
  import { BasePagination } from "@/components";
  import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
  import { mapGetters, mapActions } from "vuex";
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import moment from 'moment'
  import swal from "sweetalert2";
  
  export default {
	mixins: [clientPaginationMixin],
	components: {
	  flatPicker,
	  BasePagination,
	  RouteBreadCrumb,
	  [Select.name]: Select,
	  [Option.name]: Option,
	  [Table.name]: Table,
	  [TableColumn.name]: TableColumn,
	},
	computed: {
	  ...mapGetters({
		tableDataOrg: "WmsInventory/getHistoryStorage",
      Storage: "WmsStorage/getData",
	  Product: "WmsProduct/getDataWithAll",
	  }),
	  tableData: function () {
		// if (this.SearchKeyword != "") {
		//   return this.tableDataOrg.filter((d) => {});
		// } else {
		//   return this.tableDataOrg;
		// }
		return this.tableDataOrg;
	  },
	  tableColumns: function () {
		return [
		  {
			prop: "head_id",
			label: "HeadID",
			minWidth: 90,
			sortable: true,
		  },
		  {
			prop: "user_name",
			label: this.$t("wms.staff"),
			minWidth: 100,
			sortable: true,
		  },
		  {
			prop: "storage_name_out",
			label: "คลังต้นทาง",
			minWidth: 100,
			sortable: true,
		  },
		  {
			prop: "storage_name_in",
			label: "คลังปลายทาง",
			minWidth: 100,
			sortable: true,
		  },
		  {
			prop: "note",
			label: this.$t("wms.note"),
			minWidth: 100,
			sortable: true,
		  },
		  {
			prop: "created_at",
			label: this.$t("wms.created_at"),
			minWidth: 120,
			sortable: true,
		  },
		];
	  },
	},
	data() {
	  return {
		propsToSearch: ["Number", "Email"],
		selectedRows: [],
		SearchKeyword: "",
		showAddModal: false,
		showInOutModal: false,
		StorageID: 0,
		startDate: "",
		endDate: "",
		historyType: 0,
		wmsProductID: 0,
		md: {
		  InventoryID: 0,
		  ProductID: "-",
		  StorageID: "-",
		  Note: "",
		  Quantity: "0",
		  Cost: 0,
		},
		inOut: {
		  InventoryID: 0,
		  ProductID: 0,
		  StorageID: 0,
		  Note: "",
		  Quantity: 0,
		  Cost: 0,
		  Action: "",
		},
		rowEdit: {
		  ID: 0,
		  Number: "",
		},
		// filter type table
		HistoryTypeTable: [
		  { Name: "ทั้งหมด", ID: 0, },
		  { Name: "เบิกสินค้า", ID: 1, },
		  { Name: "แพ็คสินค้า", ID: 2, },
		],
	  };
	},
	async mounted() {
	let today = moment().format('YYYY-MM-DD');
	this.startDate = today;
	this.endDate = moment(today).add(23,'hours').add(59,'minutes').format('YYYY-MM-DD HH:mm');

	this.listProduct();
	await this.listStorage();
	if (this.Storage.length > 0 ) {
		this.StorageID = this.Storage[0].ID;
	}
	  this.SearchData();
	},
	methods: {
	  ...mapActions({
		listHistory: "WmsInventory/listHistoryStorage",
		listStorage: "WmsStorage/listData",
		listProduct: "WmsProduct/listData",
	  }),
	  SearchData() {
		let params = {
		  time_from: this.startDate,
		  time_to: this.endDate,
		  storage_id: this.StorageID,
		  history_type: this.historyType ,
		  order_id:0,
		  product_id: this.wmsProductID,
		};
		this.listHistory(params);
	  },
  
	  handleDetail(index, row) {
		// get array of detail from row
		let detail = row.detail;

		// convert field storage_name, product_name ,quantity, history_note to text
		let detailText = detail.map((d) => {
		  return {	
			storage_name: d.storage_name,
			product_name: d.product_name,
			quantity: d.quantity,
			history_note: d.history_note,
		  };
		});
		// convert detailText to html
		detailText = detailText.map((d) => {
		  return `<div class="row">
		  <div class="col-md-1">${d.storage_name}</div>
		  <div class="col-md-3">${d.product_name}</div>
		  <div class="col-md-1">${d.quantity}</div>
		  <div class="col-md-6">${d.history_note}</div>
		</div>`;
		});

		// convert detailText to string
		detailText = `<div class="row">
		  <div class="col-md-1">คลัง</div>
		  <div class="col-md-3">สินค้า</div>
		  <div class="col-md-1">จำนวน</div>
		  <div class="col-md-6">รายละเอียด</div>
		</div><hr/>` + detailText.join("");

		// show modal using swal large modal

		swal.fire({
		  title: this.$t("detail"),
		  html: detailText,
		  type: "info",
		  confirmButtonClass: "btn btn-primary btn-fill",
		buttonsStyling: false,
		  width: '90%',
		});

	  },
	  selectionChange(selectedRows) {
		this.selectedRows = selectedRows;
	  },
	},
  };
  </script>
  <style>
  .no-border-card .card-footer {
	border-top: 0;
  }
  </style>
  